const getRescheduleHostsResponse = (response) => {
  return response?.hosts?.map((host) => {
    return {
      ...host,
      value: host.id,
      label: host.name,
    };
  });
};

export default getRescheduleHostsResponse;
